"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var react_router_dom_1 = require("react-router-dom");
var locale_es_1 = __importDefault(require("../../translations/locale-es"));
var HelperSearchOrFilterContainer_styled_1 = require("./HelperSearchOrFilterContainer.styled");
var HelperSearchOrFilterContainer = function (_a) {
    var search = _a.search, filterList = _a.filterList;
    var _b = (0, react_router_dom_1.useSearchParams)(), searchParams = _b[0], setSearchParams = _b[1];
    var filterIsNotEmpty = !!filterList &&
        Object.values(filterList).filter(function (value) { return value.length > 0; })
            .length > 0;
    var handleDelete = function (filterValue) {
        if (!filterList)
            return;
        for (var _i = 0, _a = Object.keys(filterList); _i < _a.length; _i++) {
            var filterKey = _a[_i];
            searchParams.delete(filterKey, filterValue);
        }
        setSearchParams(searchParams);
    };
    var renderFilterList = function () {
        return (filterList &&
            filterIsNotEmpty &&
            Object.keys(filterList)
                .flatMap(function (key) {
                var simpleKey = key.toString().replace(/[[]]/g, '');
                var newValue = Object.values(filterList[key]).map(function (value) { return ({
                    dbKey: value,
                    label: simpleKey in locale_es_1.default
                        ? locale_es_1.default[simpleKey][value]
                        : value,
                }); });
                return newValue;
            })
                .map(function (filter, index) { return ((0, jsx_runtime_1.jsx)(material_1.Chip, { label: filter.label, variant: "outlined", onDelete: function () { return handleDelete(filter.dbKey); } }, index)); }));
    };
    return ((0, jsx_runtime_1.jsxs)(HelperSearchOrFilterContainer_styled_1.FilterHelperContainer, __assign({ style: {
            marginTop: search || (filterList && filterIsNotEmpty) ? '20px' : 0,
        } }, { children: [search !== '' && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("span", __assign({ style: { marginRight: 5 } }, { children: "Resultados de la b\u00FAsqueda por:" })), (0, jsx_runtime_1.jsx)(HelperSearchOrFilterContainer_styled_1.SpanText, { children: search }), (0, jsx_runtime_1.jsx)("span", { children: search ? '.' : '' })] })), filterList && filterIsNotEmpty && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("span", __assign({ style: { marginLeft: search !== '' ? 3 : 0, marginRight: 3 } }, { children: search !== ''
                            ? 'Con los filtros aplicados:'
                            : 'Resultados con los filtros aplicados:' })), (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ sx: {
                            display: 'flex',
                            alignItems: 'center',
                            flexWrap: { xs: 'nowrap', sm: 'wrap' },
                            gap: '5px',
                            overflowX: 'auto',
                            paddingBottom: { xs: '8px', sm: '0' },
                        } }, { children: renderFilterList() }))] }))] })));
};
exports.default = HelperSearchOrFilterContainer;
